export default __webpack_public_path__ + "static/media/signature-react2.0b00bb3f.webp";